"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("../models/globals");
class RechercheCodePostal extends webix_jet_1.JetView {
    config() {
        return {
            view: "popup",
            width: 300,
            hidden: true,
            resize: true,
            body: {
                view: "form",
                elements: [{
                        view: "search",
                        id: "codePostalSearchFieldId"
                    }, {
                        view: "list",
                        id: "codePostalSearchListId",
                        url: globals_1.phpPath + "codesPostaux.php",
                        template: "#cp# - #vi#",
                        height: 350,
                        select: true
                    }
                ]
            }
        };
    }
    filtre(obj, value) {
        let combi = obj.cp + obj.vi;
        let oNom = combi.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return oNom.toLowerCase().indexOf(value) != -1;
    }
    exit(item) {
        if (item) {
            globals_1.lv2.trace(item.codeClient);
            // @ts-ignore
            this.app.callEvent("code:postal:choisi", [item]);
        }
        this.sf.setValue("");
        this.sl.filter(function () { return true; });
        // @ts-ignore
        this.getRoot().hide();
    }
    init() {
        this.sf = this.$$("codePostalSearchFieldId");
        this.sl = this.$$("codePostalSearchListId");
        // }
        //
        // ready() {
        let me = this;
        // contrairement au snippet https://snippet.webix.com/cf384b45
        // je n'ai pas réussi à faire marcher le bind
        // me.sl.bind(me.sf, function(obj, filter){ return obj == filter; })
        this.sf.attachEvent("onTimedKeyPress", function () {
            globals_1.lv2.trace("onTimedKeyPress");
            let value = this.getValue().toLowerCase();
            me.sl.filter(function (obj) { return (me.filtre(obj, value)); });
        });
        this.sf.attachEvent("onChange", function () {
            globals_1.lv2.trace("onChange");
            let value = this.getValue().toLowerCase();
            me.sl.filter(function (obj) { return (me.filtre(obj, value)); });
        });
        this.sl.attachEvent("onEnter", function () {
            let id = me.sl.getSelectedId(false);
            if (id) {
                let item = this.getItem(id);
                me.exit(item);
            }
        });
        this.sl.attachEvent("onItemDblClick", function (id) {
            let item = this.getItem(id);
            me.exit(item);
        });
    }
    showPopup(elem, code) {
        // @ts-ignore
        this.getRoot().show(elem, { x: 200, y: 0 }); // je n'ai pas réussi à trouver une autre solution
        this.sf.focus();
        this.sf.setValue(code);
    }
}
exports.default = RechercheCodePostal;
